import { render, staticRenderFns } from "./BusinessPage.vue?vue&type=template&id=20409176&scoped=true&"
import script from "./BusinessPage.vue?vue&type=script&lang=js&"
export * from "./BusinessPage.vue?vue&type=script&lang=js&"
import style0 from "./BusinessPage.vue?vue&type=style&index=0&lang=css&"
import style1 from "./BusinessPage.vue?vue&type=style&index=1&id=20409176&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20409176",
  null
  
)

export default component.exports